"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlotInteractionConnector = void 0;
const plot_interaction_providers_1 = require("../../eventing/user-interaction/plot-interaction-providers");
const plot_event_handler_1 = require("../../eventing/user-interaction/plot-event-handler");
const on_canvas_mouse_event_1 = require("../../templating/events/on-canvas-mouse-event");
const on_canvas_pointer_event_1 = require("../../templating/events/on-canvas-pointer-event");
const on_canvas_resized_1 = require("../../templating/events/on-canvas-resized");
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Provides a reasonably generic attach point for behaviors on events. A default state machine will be supplied which
 * provides both mouse and touch events for: click, double click, pinch and mouse zooming, dragging and entity hover.
 *
 * @remarks
 * The default state machine can be extended by providing supplying a custom initial state, pointing to the extension.
 */
class PlotInteractionConnector {
    constructor(stateChangeCallbacks, options = { doubleClickOptions: { timeout: 500, maxRadius: 2 }, pinchZoomSensitivity: 1 }, createEventHandler = (initialState, plot) => new plot_event_handler_1.PlotEventHandler(initialState, plot)) {
        this.stateChangeCallbacks = stateChangeCallbacks;
        this.options = options;
        this.createEventHandler = createEventHandler;
        this.eventHandler = null;
        this.userCallbacks = null;
        this.targetProvider = null;
        this.temporaryListeners = new rc_js_util_1.TemporaryListener();
    }
    register(plot, chartEventService, getTargetProviders, getInitialState) {
        this.unregister();
        const targetProvider = this.targetProvider = getTargetProviders();
        this.userCallbacks = this.stateChangeCallbacks(targetProvider);
        const initialState = getInitialState(this.options, new plot_interaction_providers_1.PlotInteractionProviders(this.userCallbacks, targetProvider, plot.attachPoint));
        this.eventHandler = this.createEventHandler(initialState, plot);
        this.temporaryListeners.addListener(chartEventService.getCategory(on_canvas_resized_1.OnCanvasResized).addTemporaryListener(this.userCallbacks));
        this.temporaryListeners.addListener(chartEventService.getCategory(on_canvas_resized_1.OnCanvasResized).addTemporaryListener(this.eventHandler));
        this.temporaryListeners.addListener(chartEventService.getCategory(on_canvas_mouse_event_1.OnCanvasMouseEvent).addTemporaryListener(this.eventHandler));
        this.temporaryListeners.addListener(chartEventService.getCategory(on_canvas_pointer_event_1.OnCanvasPointerEvent).addTemporaryListener(this.eventHandler));
        return targetProvider;
    }
    unregister() {
        this.temporaryListeners.clearingEmit();
        this.eventHandler = null;
        this.userCallbacks = null;
    }
    update(canvasDims, startTime) {
        return this.targetProvider == null
            ? rc_js_util_1._Iterator.emptyIterator
            : this.targetProvider.update(canvasDims, startTime);
    }
}
exports.PlotInteractionConnector = PlotInteractionConnector;
//# sourceMappingURL=plot-interaction-connector.js.map